module.exports = require("react-dimensions");


/*****************
 ** WEBPACK FOOTER
 ** external "react-dimensions"
 ** module id = 99
 ** module chunks = 0
 **/